import { useTranslation } from "react-i18next";
import { Button, Typography } from "@foodpilot/foods";
import { Stack } from "@mui/material";
import type { PermissionScopeValue } from "../permissionScope";

export type ScopeEmptyStateProps = {
    onBrowseScope: (scope: PermissionScopeValue) => void;
};

export const ScopeEmptyState = (props: ScopeEmptyStateProps) => {
    const { onBrowseScope } = props;
    const { t } = useTranslation();

    return (
        <Stack
            spacing={2}
            alignItems="center"
            sx={(theme) => ({
                border: `1px dashed ${theme.custom.grey[600]}`,
                borderRadius: theme.spacing(1.5),
                padding: theme.spacing(4, 3),
                backgroundColor: theme.custom.grey[300],
            })}
        >
            <Stack spacing={0.5} alignItems="center">
                <Typography variant="h5" sx={(theme) => ({ color: theme.custom.grey[2800] })}>
                    {t("settings.roles.scope.choose_title", "Choose where to start")}
                </Typography>
                <Typography
                    variant="body-medium"
                    align="center"
                    sx={(theme) => ({ color: theme.custom.grey[2500], maxWidth: theme.spacing(60) })}
                >
                    {t(
                        "settings.roles.scope.choose_desc",
                        "The first permission sets the scope. Remove all permissions to reopen it.",
                    )}
                </Typography>
            </Stack>
            <Stack direction="row" spacing={2}>
                <Button variant="primary" onClick={() => onBrowseScope("org")}>
                    {t("settings.roles.scope.organization", "Organization")}
                </Button>
                <Button variant="secondary" onClick={() => onBrowseScope("platform")}>
                    {t("settings.roles.scope.platform", "Platform")}
                </Button>
            </Stack>
        </Stack>
    );
};
